import { createSelector } from '@reduxjs/toolkit';

import { RootState } from '../store';

const blogsState = (state: RootState) => state.blogs;

const selectBlogs = createSelector(blogsState, (state) => state.blogs || []);

const selectBlogsLoading = createSelector(
  blogsState,
  (state) => state.blogsLoading,
);

export const blogsSliceSelectors = { selectBlogs, selectBlogsLoading };
